import dayjs, { Dayjs } from 'dayjs';

export const subtractWorkdays = (startDate: Dayjs | Date | string | number, days: number): Dayjs => {
    let date = dayjs(startDate);
    const today = dayjs().startOf('day');
    while (days > 0) {
        date = date.subtract(1, 'day');

        if (date.isBefore(today)) {
            return today;
        }

        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
            days -= 1;
        }
    }

    return date;
};
